import { PropsWithChildren, useEffect, useRef } from "react";

type Message =
  | { type: "toggle"; sectionId: string }
  | { type: "scroll"; sectionId: string };

function handleMessage(root: HTMLDivElement, message: Message) {
  if (message.type === "scroll") {
    const { sectionId } = message;
    const el = root.querySelector(`#${CSS.escape(sectionId)}`);
    el?.scrollIntoView({
      behavior: "smooth",
      block: "center",
      // @ts-expect-error Some browser do not support this.
      container: "nearest",
    });
  } else if (message.type === "toggle") {
    const { sectionId } = message;
    const el = root.querySelector(`#${CSS.escape(sectionId)}`);
    if (!(el instanceof HTMLElement)) return;
    const isHidden = window.getComputedStyle(el).display === "none";
    el.style.display = isHidden ? "" : "none";
  } else {
    throw new Error("Invalid message type");
  }
}

export function Report(props: PropsWithChildren<{ embed?: boolean }>) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!props.embed) return undefined;

    function onMessage(event: MessageEvent<Message>) {
      if (event.origin !== window.location.origin) return;
      const root = ref.current;
      if (!root) return;
      handleMessage(root, event.data);
    }

    window.addEventListener("message", onMessage);
    return () => {
      window.removeEventListener("message", onMessage);
    };
  }, [props.embed]);

  return <div ref={ref}>{props.children}</div>;
}
